import { Anchor } from '@components/Anchor';
import { CsvButton } from '@components/Buttons/CsvButton';
import { LinkText } from '@components/LinkText';
import { Pagination } from '@components/Table/Pagination';
import { TableKeyCell } from '@components/Table/TableKeyCell';
import { TableNoResult } from '@components/Table/TableNoResult';
import { TableSortCell } from '@components/Table/TableSortCell';
import { TableSortRow } from '@components/Table/TableSortRow';
import { IData } from '@hooks/useData';
import useFormatter from '@hooks/useFormatter';
import { useModalWindow } from '@hooks/useModalWindow';
import { TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import { FaturaDetalheModal } from '@mod/Fatura/FaturaDetalheModal';
import { useFaturaTipoColor } from '@model/Fatura';
import { useFaturaStatusColor } from '@model/FaturaStatus';
import { IInadimplenciaFaturaFilter, IInadimplenciaFaturaRecord } from '@services/RelatorioService';
import React from 'react';

export type InadimplenciaFaturaTableProps = {
    data: IData<IInadimplenciaFaturaRecord, IInadimplenciaFaturaFilter>
    isLoading: boolean
    onCsvButtonClick: VoidFunction
}

export function InadimplenciaFaturaTable ({ data, onCsvButtonClick, isLoading }: InadimplenciaFaturaTableProps) {
    const formatter = useFormatter();
    const faturaStatusColor = useFaturaStatusColor();
    const faturaDetalheModal = useModalWindow();
    const faturaTipoColor = useFaturaTipoColor();

    return (
        <React.Fragment>
            <TableNoResult itemCount={data.itemsCount}>
                <TableHead>
                    <Pagination pagination={data.pagination}>
                        <CsvButton onClick={onCsvButtonClick} disabled={isLoading} />
                    </Pagination>

                    <TableSortRow sort={data.sort}>
                        <TableSortCell fieldName="faturaId">Fatura ID</TableSortCell>
                        <TableSortCell fieldName="empresaNome">Empresa</TableSortCell>
                        <TableSortCell fieldName="clienteNome">Cliente</TableSortCell>
                        <TableSortCell fieldName="clienteCpf">CPF</TableSortCell>
                        <TableSortCell fieldName="clienteTelefone">Celular</TableSortCell>
                        <TableSortCell fieldName="competenciaReferencia">Competência</TableSortCell>
                        <TableSortCell fieldName="dataVencimento">Vencimento</TableSortCell>
                        <TableSortCell fieldName="valorPago">Vlr. Pago</TableSortCell>
                        <TableSortCell fieldName="saldo">Saldo Restante</TableSortCell>
                        <TableSortCell fieldName="avulsa">Tipo</TableSortCell>
                        <TableSortCell fieldName="status">Status</TableSortCell>
                    </TableSortRow>
                </TableHead>
                
                <TableBody>
                    {
                        data.items.map((inadimplenciaFaturaRecord, index) => {
                            return (
                                <TableRow key={index}>
                                    <TableKeyCell><Anchor onClick={data.handleRowFocused(inadimplenciaFaturaRecord, faturaDetalheModal.open)}>{inadimplenciaFaturaRecord.faturaId}</Anchor></TableKeyCell>
                                    <TableCell>{inadimplenciaFaturaRecord.empresaNome}</TableCell>
                                    <TableCell><LinkText to={`/cliente/${inadimplenciaFaturaRecord.clienteId}`} text={inadimplenciaFaturaRecord.clienteNome} /></TableCell>
                                    <TableCell>{inadimplenciaFaturaRecord.clienteCpf}</TableCell>
                                    <TableCell>{inadimplenciaFaturaRecord.clienteTelefone}</TableCell>
                                    <TableCell>{formatter.toCompetencia(inadimplenciaFaturaRecord.competenciaReferencia)}</TableCell>
                                    <TableCell>{formatter.toDate(inadimplenciaFaturaRecord.dataVencimento)}</TableCell>
                                    <TableCell>{formatter.toFloat(inadimplenciaFaturaRecord.valorPago)}</TableCell>
                                    <TableCell>{formatter.toFloat(inadimplenciaFaturaRecord.saldo)}</TableCell>

                                    <TableCell className={faturaTipoColor[inadimplenciaFaturaRecord.tipo]}>
                                        { inadimplenciaFaturaRecord.tipo }
                                    </TableCell>

                                    <TableCell 
                                        className={faturaStatusColor[inadimplenciaFaturaRecord.faturaStatusId]}
                                    >
                                        { inadimplenciaFaturaRecord.faturaStatusNome }
                                    </TableCell>
                                </TableRow>
                            )
                        })
                    }

                    <Pagination pagination={data.pagination}>
                        <CsvButton onClick={onCsvButtonClick} disabled={isLoading} />
                    </Pagination>

                </TableBody>
            </TableNoResult>

            {
                data.focusedRow !== undefined && (
                    <FaturaDetalheModal 
                        faturaId={data.focusedRow.faturaId}
                        modal={faturaDetalheModal}
                    />
                )
            }
        </React.Fragment>
    )
}